var map = {
	"./ar.json": "b4cb",
	"./be.json": "5185",
	"./ch.json": "503f",
	"./cn.json": "1b03",
	"./de.json": "bac1",
	"./el.json": "af80",
	"./en.json": "e312",
	"./es.json": "ef52",
	"./et.json": "101e",
	"./fi.json": "bf68",
	"./fr.json": "b16e",
	"./he.json": "1130",
	"./it.json": "669f",
	"./ka.json": "8444",
	"./km.json": "417e",
	"./lt.json": "8b66",
	"./lv.json": "da5a",
	"./pl.json": "1c57",
	"./pt.json": "de6e",
	"./ro.json": "a268",
	"./ru.json": "3a06",
	"./sp.json": "1811",
	"./tg.json": "e754",
	"./th.json": "5b02",
	"./tr.json": "af45",
	"./uk.json": "5f36"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a35b";